let animationObject={initialAttr:{opacity:0},finalAttr:{opacity:1},slot:'initial'};export default{"initial.canvas.canvas":{"canvas.appearing":[animationObject]}};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-charts/src/_internal/components/canvases/canvas3d.animation.js
// module id = null
// module chunks = 